import angular from 'angular';

class modalCheckImportPrincipalCtrl {
    /*@ngInject*/
    constructor($translate, CONF, logger, PrincipalSvc, $uibModal, $state) {
        this.$translate = $translate;
        this.CONF = CONF;
        this.PrincipalSvc = PrincipalSvc;
        this.logger = logger;
        this.$uibModal = $uibModal;
        this.$state = $state;
    }

    $onInit() {
        this.includes = {
            errorMessages: require('../../layouts/error-messages.html'),
        };
        // // Affichage des étapes de l'import
        this.displayForm = false;
        this.displayLoad = false;
        this.displayResult = false;
        this.manageDisplay('form');
    }

    importZip() {
        this.manageDisplay('load');
        this.PrincipalSvc.checkImportConfDo(this.file).then(
            result => {
                this.progressTitle = this.$translate.instant('principal.principal.import.title');
                this.displayProgress = true;
                this.taskId = result.data;
            },
            error => {
                if (error.status === 400 && error.data && error.data.code === 'OPERATION_ALREADY_IN_EXECUTION') {
                    this.logger.error('error.operation_already_inprogress');
                    this.cancel();
                } else {
                    this.file = null;
                    this.logger.error('error.import');
                    this.manageDisplay('form');
                }
            }
        );
    }

    onTaskEnd(results) {
        this.displayProgress = false;
        this.modalInstance.close(true);
        if (!results.success) {
            this.$uibModal.open({
                component: 'modalErrorImportPrincipalCtrl',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    error: () => {
                        return results.error.message;
                    },
                },
            });
        } else {
            this.$state.go('app.principal.principalImport', { importResults: results.result });
        }
    }

    cancel() {
        this.modalInstance.dismiss('cancel');
    }

    ok() {
        this.modalInstance.close(false);
    }

    manageDisplay(step) {
        switch (step) {
            case 'form':
                this.displayForm = true;
                this.displayLoad = false;
                this.displayResult = false;
                break;
            case 'load':
                this.displayForm = false;
                this.displayLoad = true;
                this.displayResult = false;
                break;
            case 'result':
                this.displayForm = false;
                this.displayLoad = false;
                this.displayResult = true;
                break;
        }
    }
}

angular.module('app.principal').component('modalCheckImportPrincipal', {
    templateUrl: require('./modal-check-import-principal.html'),
    controller: modalCheckImportPrincipalCtrl,
    bindings: {
        modalInstance: '<',
    },
});
